import React from 'react'
import './firstPage.scss'

const FirstPage = () => (
  <div className="firstPage">
    <p className="firstPage_content"> Welcome to Whispers! </p>
    <p className="firstPage_content2"> Sign in or Sign up to get chatting </p>
  </div>
)

export default FirstPage



// WEBPACK FOOTER //
// ./src/pages/firstPage.js